var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    d: "M104.048 59.817a44.227 44.227 0 1 1-44.224-44.224 44.224 44.224 0 0 1 44.224 44.224Z",
    "data-name": "Path 37810"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    d: "M117.141 59.818A57.32 57.32 0 1 1 59.823 2.5a57.317 57.317 0 0 1 57.318 57.318Z",
    "data-name": "Path 37811"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    d: "m107.422 93.094 12.693 12.693-10.448 10.453-12.7-12.693",
    "data-name": "Path 37812"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    d: "m162.517 146.994-11.645 11.649a4.493 4.493 0 0 1-6.352 0l-35.448-35.455a4.483 4.483 0 0 1 0-6.352l11.639-11.648a4.5 4.5 0 0 1 6.357 0l35.449 35.455a4.493 4.493 0 0 1 0 6.351Z",
    "data-name": "Path 37813"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.7,
    d: "M55.201 103.103a12.675 12.675 0 0 0 1.748-5.1",
    "data-name": "Path 37814"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "2.115 3.12",
    strokeWidth: 1.7,
    d: "M57.845 93.525c.228-9.265-17.726-18.389-21.34-23.995-6.978-10.82.529-21.944 6.746-24.963 25.521-12.379 35.751 19.649 52.612 13.669",
    "data-name": "Path 37815"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.7,
    d: "M98.334 56.863a29.355 29.355 0 0 0 4.453-3.1",
    "data-name": "Path 37816"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "2 3",
    strokeMiterlimit: 10,
    strokeWidth: 1.7,
    d: "M50.45 117.137a53.911 53.911 0 0 1-20.468 32.684c-6.314 4.716-9.392 10.145-10.734 15.182",
    "data-name": "Path 37817"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "2 3",
    strokeMiterlimit: 10,
    strokeWidth: 1.7,
    d: "M163.573 94.869c-4.8-4.626-11.54-19.461-14.8-28.388-7.61-20.825-31.632-18.829-31.632-18.829",
    "data-name": "Path 37818"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.0339bf39fc02ed2ed27fe08b649b1196.svg";
export { ForwardRef as ReactComponent };